import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import Lottie from "lottie-react";
import animation from "./Animation-Registro.json";
import SingleStepService from "../components/SingleStepService";
import SinglePlatformBoxService from "../components/SinglePlatformBoxService";
import SingleStepServicePopup from "../components/SingleStepServicePopup";

const Content2 = () => {
  const [openPopup, setOpenPopup] = useState(false);
  const [stepNumber, setStepNumber] = useState(null);
  const [scrollPosition, setScrollPosition] = useState(0);
  const platformsRef = useRef(null);
  const location = useLocation();
  const contactsShipsta = ["hr@shipsta.com", "hola@shipsta.com", "+ 352 278 631 80"];
  const contactsISM = ["p2p-precalificacion@holcim.com"];
  const contactsJaggaer = ["info.proveedoresmexico@holcim.com"];
  const contactsSRM = [" info.proveedoresmexico@holcim.com ", "+57 311 221 93 65"];

  const openPopupHandler = (numero) => {
    setStepNumber(numero);
    setScrollPosition(window.pageYOffset);
    setOpenPopup(true);
  };

  const closePopupHandler = () => {
    setOpenPopup(false);
  };

  useEffect(() => {
    if (openPopup) {
      document.body.style.overflow = "hidden";
      window.scrollTo(0, scrollPosition);
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [openPopup, scrollPosition]);

  useEffect(() => {
    if (location.hash === '#steps-section' && platformsRef.current) {
      const smoothScrollTo = (targetPosition, duration) => {
        const startPosition = window.pageYOffset;
        const distance = targetPosition - startPosition;
        let startTime = null;

        const easeInOutCubic = (t) => {
          return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
        };

        const animation = (currentTime) => {
          if (startTime === null) startTime = currentTime;
          const timeElapsed = currentTime - startTime;
          const progress = Math.min(timeElapsed / duration, 1);
          const easeProgress = easeInOutCubic(progress);

          window.scrollTo(0, startPosition + distance * easeProgress);

          if (timeElapsed < duration) {
            requestAnimationFrame(animation);
          }
        };

        requestAnimationFrame(animation);
      };

      setTimeout(() => {
        const targetPosition = platformsRef.current.getBoundingClientRect().top + window.pageYOffset;
        smoothScrollTo(targetPosition, 1200);
      }, 100);
    }
  }, [location]);

  return (
    <div>
      <div ref={platformsRef} id="steps-section" className="steps-section">
        <div className="sub-box">
          <h6>
            Si aún no eres un proveedor registrado de Holcim y deseas serlo, sigue
            los siguientes pasos de nuestro Proceso de alta:
          </h6>

          <div className="container">
            <div className="gif-wrapper">
              <Lottie
                animationData={animation}
                loop={true}
                style={{ width: "390px", height: "390px" }}
              />
            </div>
            <div className="steps-wrapper">
              <SingleStepService
                numero={1}
                titulo="Prevaloración"
                texto="Completa nuestro Formulario de Prevaloración de Proveedores"
                boton="Ir al formulario"
                icono={true}
                href="https://docs.google.com/forms/d/e/1FAIpQLScbawstY8cesyn7Omw46RqrZABo-hJ33_O2kdKxYkin6tSddQ/viewform"
              />
              <SingleStepService
                numero={2}
                titulo="Alta proveedor"
                texto="Una vez que el comprador se haya puesto en contacto contigo, realizara su registro para el alta. Prepara los documentos necesarios para iniciar tu proceso de alta."
                boton="Ver la lista de documentos"
                showPopup={true}
                openPopupHandler={() => openPopupHandler(2)}
              />
              <SingleStepService
                numero={3}
                titulo="Precalificación (ISM)"
                texto="Completa los cuestionarios de precalificación sobre la gestión de tu empresa"
                boton="Ir al cuestionario"
                icono={true}
                href="https://vendormaster.holcimvmp-la.com/login"
              />
              <SingleStepService
                numero={4}
                titulo="Supplier Relationship Management"
                texto="Accede a material de capacitación sobre nuestra plataforma SRM"
                boton="Manuales y Capacitaciones"
                showPopup={true}
                openPopupHandler={() => openPopupHandler(4)}
              />
              <SingleStepService
                numero={5}
                titulo="Cumplimiento H&S"
                texto="Necesitarás cumplir con los requisitos de seguridad y medio ambiente"
                boton="Ver más"
                href= "/assets/manuales/requisitosProveedor.pdf"
              />
            </div>
          </div>
          <p className="steps-info-note">
            Si bajas encontrarás los links y números de contacto para el proceso que tengas pendiente
          </p>
        </div>
      </div>

      <div className="platforms-section">
        <div className="section-text">
          <div className="tittle">Plataformas y herramientas</div>
          <div className="text">
            Accede a las aplicaciones disponibles para ti
          </div>
        </div>
        <div className="platforms-boxes">
          <SinglePlatformBoxService
            tittle="SHIPSTA"
            text="Portal a través del cual se solicitan cotizaciones para rutas"
            buttonText="Ir a SHIPSTA"
            img="/assets/platforms-icons/Plataformas-Shipsta.png"
            imgAlt="SHIPSTA Logo"
            href="https://www.shipsta.com/"
            contacts={contactsShipsta}
            manuals={[
              { href: "/assets/manuales/SHIPSTA/SHIPSTA-How-to-quote-LSP-Relaunch-ES.mp4", text: "Cómo cotizar en SHIPSTA" }
            ]}
          />
          <SinglePlatformBoxService
            tittle="ISM"
            text="Plataforma de ingreso para nuevos proveedores"
            buttonText="Ir a ISM"
            img="/assets/platforms-icons/Plataformas-ISM.png"
            imgAlt="ISM Logo"
            href="https://vendormaster.holcimvmp-la.com/login"
            contacts={contactsISM}
            manuals={[
              { href: "/assets/manuales/ISM/Manual de proveedores PreQ ABS Platform.pdf", text: "Manual de proveedores PreQ ABS Platform" },
              { href: "/assets/manuales/ISM/Guía para planes de acción.pdf", text: "Guía para planes de acción" },
              { href: "/assets/manuales/ISM/INFOGRAFÍA.pdf", text: "Infografía" }
            ]}
          />
          <SinglePlatformBoxService
            tittle="JAGGAER"
            text="Portal a través del cual se realizan subastas para equipos"
            buttonText="Ir a JAGGAER"
            img="/assets/platforms-icons/Plataformas-Jaggaer.png"
            imgAlt="JAGGAER Logo"
            href="https://lafargeholcim.bravosolution.com/"
            contacts={contactsJaggaer}
            manuals={[
              { href: "/assets/manuales/Jaggaer/Guía para Proveedores.pdf", text: "Guía para Proveedores" }
            ]}
          />
          <SinglePlatformBoxService
            tittle="SRM"
            text="Plataforma utilizada para el pago, estado de cuenta, aprobación de pedidos y comprobantes de pago"
            buttonText="Ir a SRM"
            img="/assets/platforms-icons/Plataformas-GenericHolcim.png"
            imgAlt="SRM Logo"
            contacts={contactsSRM}
            href="https://www.laseritsconline.com:47449/irj/portal/"
            manuals={[
              { href: "/assets/manuales/SRM/Manual DirectA MX 2023.pdf", text: "Manual DirectA MX 2023" }
            ]}
          />
        </div>
      </div>

      <div className="sostenibility-section">
        <div className="top-part">
          <div className="title">Beneficios por Sostenibilidad</div>
          <div className="text">
            Invitamos a nuestros proveedores a unirse a nuestra misión de crear un
            futuro más sostenible, explorando las oportunidades de colaboración y
            los incentivos disponibles.
          </div>
        </div>
        <div className="down-part">
          <div className="content">
            <div className="text">
              Con CrediProveedores obtienes las mejores condiciones de
              descuento,&nbsp;
              <strong>
                si en tu precalificación quedas como proveedor sostenible bajo el
                estándar Holcim,&nbsp;
              </strong>
              obtendrás los siguientes beneficios:
            </div>
            <div className="icons-container">
              <div className="single-icon">
                <div className="icon">
                  <img src="/assets/icons/Icon-Liquidez.svg" alt="" />
                </div>
                <div className="text">
                  <strong>Liquidez inmediata</strong> <br />
                  Recibe tu pago de manera rápida y sin esperas
                </div>
              </div>
              <div className="single-icon">
                <div className="icon">
                  <img src="/assets/icons/Icon-Cobro.svg" alt="" />
                </div>
                <div className="text">
                  <strong>Certeza de cobro</strong> <br />
                  Garantiza el pago puntual y seguro de tus servicios
                </div>
              </div>
              <div className="single-icon">
                <div className="icon">
                  <img src="/assets/icons/Icon-Papeleo.svg" alt="" />
                </div>
                <div className="text">
                  <strong>Menos papeleo</strong> <br />
                  No requiere información financiera ni estudio de crédito
                </div>
              </div>
              <div className="single-icon">
                <div className="icon">
                  <img src="/assets/icons/Icon-Deudas.svg" alt="" />
                </div>
                <div className="text">
                  <strong>Evita deudas</strong> <br />
                  No se registrarán pasivos financieros
                </div>
              </div>
              <div className="single-icon">
                <div className="icon">
                  <img src="/assets/icons/Icon-Factoraje.svg" alt="" />
                </div>
                <div className="text">
                  <strong>Factoraje eficiente</strong> <br />
                  Anticipa fácil, en línea, cuando tú quieras
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SingleStepServicePopup
        open={openPopup}
        closePopup={closePopupHandler}
        stepNumber={stepNumber}
      />
    </div>
  );
};
export default Content2;
